/**
 * MIINIDA — GTM Data Layer Client-side Tracking
 * GTM Container: GTM-5J7MMT9J
 * 의존성: miinida-datalayer.liquid (window.__MIINIDA_PAGE__ 필요)
 * 위치: Shopify Admin > Themes > Assets > miinida-tracking.js
 *       theme.liquid </body> 직전에 <script src="{{ 'miinida-tracking.js' | asset_url }}" defer></script>
 */

(function () {
  'use strict';

  // ─────────────────────────────────────────────────────────────
  // CORE UTILITIES
  // ─────────────────────────────────────────────────────────────

  var DL   = window.dataLayer = window.dataLayer || [];
  var PAGE = window.__MIINIDA_PAGE__ || { page_type: 'unknown' };
  var HERO_HANDLE = 'miinida-calm-brightening-serum';

  function push(obj) {
    // GA4 이커머스 이벤트 전 이전 ecommerce 객체 초기화 (GA4 중복 방지)
    if (obj.ecommerce) DL.push({ ecommerce: null });
    DL.push(obj);
  }

  function onReady(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  function isHeroPage() {
    return PAGE.is_hero_product === true;
  }

  function closest(el, selector) {
    if (!el) return null;
    if (el.closest) return el.closest(selector);
    // IE fallback
    var current = el;
    while (current && current !== document) {
      if (current.matches && current.matches(selector)) return current;
      current = current.parentElement;
    }
    return null;
  }

  // ─────────────────────────────────────────────────────────────
  // CART AJAX INTERCEPT
  // /cart/add.js  → add_to_cart
  // /cart/change.js → remove_from_cart (수량 0으로 변경 시)
  // ─────────────────────────────────────────────────────────────

  (function interceptCart() {
    // fetch 기반 인터셉트 (Shopify Dawn 계열 테마)
    var _origFetch = window.fetch;
    window.fetch = function (resource, options) {
      var url = typeof resource === 'string' ? resource : (resource.url || '');
      var method = (options && options.method || 'GET').toUpperCase();

      return _origFetch.apply(this, arguments).then(function (response) {
        var clone = response.clone();

        if (url.includes('/cart/add') && method === 'POST') {
          clone.json().then(function (data) {
            if (!data || !data.id) return;
            var lineItems = data.items || [data];
            var totalValue = lineItems.reduce(function (sum, item) {
              return sum + (item.price / 100) * item.quantity;
            }, 0);

            push({
              event: 'add_to_cart',
              ecommerce: {
                currency: PAGE.currency || 'USD',
                value: Math.round(totalValue * 100) / 100,
                button_type: 'add_to_cart',
                items: lineItems.map(function (item, i) {
                  return {
                    item_id:       item.handle,
                    item_name:     item.product_title,
                    item_brand:    item.vendor,
                    item_category: item.product_type,
                    item_variant:  item.variant_title,
                    price:         item.price / 100,
                    quantity:      item.quantity,
                    index:         i
                  };
                })
              }
            });
          }).catch(function () {});
        }

        if (url.includes('/cart/change') && method === 'POST') {
          clone.json().then(function (cart) {
            if (!cart) return;
            // change.js 요청 본문에서 제거 대상 파악 (options.body)
            try {
              var body = JSON.parse(options && options.body || '{}');
              if (body.quantity === 0 && body.id) {
                var removedLine = null;
                // 제거된 아이템 정보를 localStorage에서 복원 (이전 카트 스냅샷 활용)
                var prevCart = JSON.parse(localStorage.getItem('miinida_cart') || '{}');
                if (prevCart.items) {
                  removedLine = prevCart.items.find(function (i) {
                    return String(i.variant_id) === String(body.id) || String(i.key) === String(body.id);
                  });
                }
                if (removedLine) {
                  push({
                    event: 'remove_from_cart',
                    ecommerce: {
                      currency: cart.currency || PAGE.currency || 'USD',
                      value: (removedLine.price / 100) * removedLine.quantity,
                      items: [{
                        item_id:       removedLine.handle,
                        item_name:     removedLine.product_title,
                        price:         removedLine.price / 100,
                        quantity:      removedLine.quantity,
                        item_variant:  removedLine.variant_title
                      }]
                    }
                  });
                }
              }
            } catch (e) {}
            // 카트 스냅샷 갱신
            localStorage.setItem('miinida_cart', JSON.stringify(cart));
          }).catch(function () {});
        }

        return response;
      });
    };

    // XHR 기반 인터셉트 (Shopify Symmetry 테마 등 구형 테마)
    var _origOpen = XMLHttpRequest.prototype.open;
    var _origSend = XMLHttpRequest.prototype.send;

    XMLHttpRequest.prototype.open = function (method, url) {
      this._mn_url    = url;
      this._mn_method = method;
      return _origOpen.apply(this, arguments);
    };

    XMLHttpRequest.prototype.send = function (body) {
      var self = this;
      var url  = this._mn_url || '';

      if (url.includes('/cart/add')) {
        this.addEventListener('load', function () {
          if (self.status !== 200) return;
          try {
            var data = JSON.parse(self.responseText);
            if (!data || !data.id) return;
            var lineItems = data.items || [data];
            var totalValue = lineItems.reduce(function (s, i) { return s + (i.price / 100) * i.quantity; }, 0);

            push({
              event: 'add_to_cart',
              ecommerce: {
                currency: PAGE.currency || 'USD',
                value: Math.round(totalValue * 100) / 100,
                button_type: 'add_to_cart',
                items: lineItems.map(function (item, idx) {
                  return {
                    item_id:       item.handle,
                    item_name:     item.product_title,
                    item_brand:    item.vendor,
                    item_category: item.product_type,
                    item_variant:  item.variant_title,
                    price:         item.price / 100,
                    quantity:      item.quantity,
                    index:         idx
                  };
                })
              }
            });
          } catch (e) {}
        });
      }

      return _origSend.apply(this, arguments);
    };

    // 초기 카트 스냅샷 저장
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
      localStorage.setItem('miinida_cart', JSON.stringify(c));
    }).catch(function () {});
  })();

  // ─────────────────────────────────────────────────────────────
  // SCROLL DEPTH TRACKER
  // 이벤트명: product_scroll_depth | blog_scroll_depth
  // ─────────────────────────────────────────────────────────────

  function initScrollDepth() {
    var milestones = [25, 50, 75, 100];
    var fired = {};
    var pageType = PAGE.page_type;
    var eventName = pageType === 'product' ? 'product_scroll_depth' : 'blog_scroll_depth';

    function getScrollPct() {
      var el  = document.documentElement;
      var max = Math.max(el.scrollHeight, document.body.scrollHeight) - window.innerHeight;
      if (max <= 0) return 100;
      return Math.min(100, Math.round((window.pageYOffset / max) * 100));
    }

    function onScroll() {
      var pct = getScrollPct();
      milestones.forEach(function (m) {
        if (!fired[m] && pct >= m) {
          fired[m] = true;
          var eventObj = { event: eventName, scroll_depth: m };
          if (PAGE.product)  eventObj.product_id    = PAGE.product.handle;
          if (PAGE.article)  eventObj.article_title = PAGE.article.title;
          push(eventObj);
        }
      });
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll(); // 첫 로드 시 체크 (100% 짧은 페이지 대응)
  }

  // ─────────────────────────────────────────────────────────────
  // ELEMENT VISIBILITY TRACKER (IntersectionObserver)
  // ─────────────────────────────────────────────────────────────

  function watchVisibility(selector, eventName, getParams, threshold) {
    if (!window.IntersectionObserver) return;
    var seen = new WeakSet();

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting && !seen.has(entry.target)) {
          seen.add(entry.target);
          var params = getParams(entry.target);
          push(Object.assign({ event: eventName }, params));
        }
      });
    }, { threshold: threshold || 0.5 });

    document.querySelectorAll(selector).forEach(function (el) {
      observer.observe(el);
    });
  }

  // ─────────────────────────────────────────────────────────────
  // HERO PRODUCT — 심층 행동 추적
  // 히어로 제품 PDP 전용 이벤트
  // ─────────────────────────────────────────────────────────────

  function initHeroProductTracking() {
    var product = PAGE.product;
    if (!product) return;

    // ── 갤러리 이미지 변경 ──────────────────────────────────────
    // Symmetry 테마는 슬라이더 버튼을 사용
    document.addEventListener('click', function (e) {
      // 썸네일 클릭
      var thumb = closest(e.target, '.product-single__thumbnail, [data-media-id], .media-gallery__thumb');
      if (thumb) {
        var thumbItems = Array.from(document.querySelectorAll('.product-single__thumbnail, [data-media-id], .media-gallery__thumb'));
        var idx = thumbItems.indexOf(thumb) + 1;
        push({
          event: 'product_gallery_changed',
          product_id:  product.handle,
          image_index: idx,
          direction:   'thumbnail'
        });
        return;
      }

      // 이전/다음 버튼
      var navBtn = closest(e.target, '.product-single__carousel-prev, .product-single__carousel-next, [class*="gallery-prev"], [class*="gallery-next"], [aria-label*="Previous" i], [aria-label*="Next" i]');
      if (navBtn) {
        var label = (navBtn.getAttribute('aria-label') || navBtn.className || '').toLowerCase();
        var dir   = label.includes('prev') ? 'prev' : 'next';
        push({
          event: 'product_gallery_changed',
          product_id: product.handle,
          direction:  dir
        });
      }
    });

    // ── 수량 변경 ───────────────────────────────────────────────
    var qtySelectors = ['input[name="quantity"]', '.quantity__input', '.product-form__quantity input'];
    qtySelectors.forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (input) {
        var prev = parseInt(input.value) || 1;
        input.addEventListener('change', function () {
          var next = parseInt(this.value) || 1;
          if (next !== prev) {
            push({
              event:             'product_quantity_changed',
              product_id:        product.handle,
              previous_quantity: prev,
              new_quantity:      next
            });
            prev = next;
          }
        });
      });
    });

    // ── BUY IT NOW 클릭 ─────────────────────────────────────────
    document.addEventListener('click', function (e) {
      var btn = closest(e.target,
        '[name="goto_webpay"], .shopify-payment-button__button, ' +
        '[data-shopify="payment-button"], .dynamic-checkout__content button'
      );
      if (btn) {
        push({
          event:      'buy_it_now_clicked',
          product_id: product.handle,
          value:      product.price,
          currency:   PAGE.currency || 'USD'
        });
      }
    });

    // ── FAQ 아코디언 열기 ────────────────────────────────────────
    document.addEventListener('click', function (e) {
      var toggle = closest(e.target,
        'details > summary, .accordion__title, [data-accordion-trigger], [class*="faq"] h3, [class*="faq"] button'
      );
      if (!toggle) return;

      var text     = toggle.textContent.trim().substring(0, 120);
      var allToggles = Array.from(document.querySelectorAll(
        'details > summary, .accordion__title, [data-accordion-trigger], [class*="faq"] h3'
      ));
      var idx = allToggles.indexOf(toggle);

      push({
        event:        'faq_expanded',
        product_id:   product.handle,
        faq_question: text,
        faq_index:    idx + 1
      });
    });

    // ── 섹션별 가시성 추적 ──────────────────────────────────────
    // Symmetry 테마 섹션 클래스 기준 — 필요 시 수동 data-section 속성 추가
    var sections = [
      { sel: '.product-single__media-wrapper, [class*="product__gallery"]', name: 'hero' },
      { sel: '[class*="ingredient"], [class*="benefit"], .product-single__description', name: 'ingredients' },
      { sel: '[class*="review"], .spr-container, #shopify-product-reviews', name: 'reviews' },
      { sel: '[class*="faq"], [class*="accordion"]', name: 'faq' }
    ];

    sections.forEach(function (s) {
      watchVisibility(s.sel, 'product_section_viewed', function () {
        return { section_name: s.name, product_id: product.handle };
      });
    });

    // ── 리뷰 섹션 전용 ──────────────────────────────────────────
    watchVisibility(
      '[class*="review"], .spr-container, #shopify-product-reviews',
      'review_section_viewed',
      function (el) {
        var countEl = el.querySelector('[class*="count"], .spr-summary-count, [class*="rating-count"]');
        var ratingEl = el.querySelector('[class*="average"], .spr-summary-starrating, [class*="rating-value"]');
        return {
          product_id:   product.handle,
          review_count: countEl ? parseInt(countEl.textContent) || 0 : 0,
          avg_rating:   ratingEl ? parseFloat(ratingEl.textContent) || 0 : 0
        };
      }
    );
  }

  // ─────────────────────────────────────────────────────────────
  // 홈페이지 이벤트
  // ─────────────────────────────────────────────────────────────

  function initHomepageTracking() {
    // ── 히어로 배너 CTA 클릭 ────────────────────────────────────
    document.addEventListener('click', function (e) {
      var cta = closest(e.target,
        '.slideshow__slide a[href*="/products"], .hero a[href*="/products"], ' +
        '[class*="banner"] a[href*="/products"], [class*="slide"] a[href*="/product"]'
      );
      if (!cta) return;

      var slide    = closest(cta, '[class*="slide"], [class*="banner"]');
      var allSlides = Array.from(document.querySelectorAll('[class*="__slide"], [class*="banner__item"]'));
      var slideIdx  = slide ? (allSlides.indexOf(slide) + 1) : 1;

      push({
        event:           'hero_cta_clicked',
        banner_slide:    slideIdx,
        cta_text:        cta.textContent.trim(),
        cta_destination: cta.getAttribute('href')
      });
    });

    // ── 뉴스레터 팝업 노출 ──────────────────────────────────────
    // MutationObserver로 팝업 DOM 진입 감지
    if (window.MutationObserver) {
      var popupFired = false;
      new MutationObserver(function (mutations) {
        if (popupFired) return;
        mutations.forEach(function (m) {
          m.addedNodes.forEach(function (node) {
            if (node.nodeType !== 1) return;
            var popup = node.matches && node.matches('[class*="newsletter-popup"], [class*="email-popup"], dialog')
              ? node
              : node.querySelector('[class*="newsletter-popup"], [class*="email-popup"], dialog');
            if (popup && !popupFired) {
              popupFired = true;
              push({
                event:        'newsletter_popup_viewed',
                offer_text:   '15% OFF',
                trigger_type: 'time_delay'
              });
            }
          });
        });
      }).observe(document.body, { childList: true, subtree: true });
    }

    // ── 블로그 미리보기 카드 클릭 ───────────────────────────────
    document.addEventListener('click', function (e) {
      var link = closest(e.target, 'a[href*="/blogs/news/"]');
      if (!link) return;
      var titleEl = link.querySelector('h2, h3, [class*="title"]') || link;
      push({
        event:         'blog_preview_clicked',
        article_url:   link.getAttribute('href'),
        article_title: titleEl.textContent.trim().substring(0, 100)
      });
    });
  }

  // ─────────────────────────────────────────────────────────────
  // 뉴스레터 이메일 제출 (모든 페이지 공통)
  // ─────────────────────────────────────────────────────────────

  function initNewsletterTracking() {
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form.querySelector('input[type="email"]')) return;

      var location = 'unknown';
      if (closest(form, 'dialog, [class*="popup"], [class*="modal"]')) location = 'popup';
      else if (closest(form, 'footer, [class*="footer"]')) location = 'footer';
      else if (closest(form, '[class*="newsletter"], [class*="email-capture"]')) location = 'section';

      push({
        event:         'newsletter_submitted',
        form_location: location,
        page_type:     PAGE.page_type
      });
    });
  }

  // ─────────────────────────────────────────────────────────────
  // 장바구니 드로어 & 결제
  // ─────────────────────────────────────────────────────────────

  function initCartTracking() {
    // ── 장바구니 아이콘 클릭 → view_cart ────────────────────────
    document.addEventListener('click', function (e) {
      var trigger = closest(e.target,
        'a[href="/cart"], [data-cart-toggle], [aria-label*="Cart" i], ' +
        '[aria-label*="cart" i], [class*="cart-icon"], [class*="cart__toggle"]'
      );
      if (!trigger || closest(trigger, 'form')) return; // 체크아웃 버튼 제외

      setTimeout(function () {
        fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
          if (!cart || cart.item_count === 0) return;
          push({
            event: 'view_cart',
            ecommerce: {
              currency:   cart.currency,
              value:      cart.total_price / 100,
              item_count: cart.item_count,
              items:      cart.items.map(function (item, i) {
                return {
                  item_id:       item.handle,
                  item_name:     item.product_title,
                  item_brand:    item.vendor,
                  item_category: item.product_type,
                  item_variant:  item.variant_title,
                  price:         item.price / 100,
                  quantity:      item.quantity,
                  index:         i
                };
              })
            }
          });
        }).catch(function () {});
      }, 150);
    });

    // ── 결제 시작 → begin_checkout ──────────────────────────────
    document.addEventListener('click', function (e) {
      var btn = closest(e.target,
        '[href*="/checkout"], [name="checkout"], ' +
        'button[data-checkout], .cart__checkout-button, [class*="checkout-button"]'
      );
      if (!btn) return;

      fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
        push({
          event: 'begin_checkout',
          ecommerce: {
            currency: cart.currency,
            value:    cart.total_price / 100,
            coupon:   (cart.cart_level_discount_applications || []).map(function (d) { return d.title; }).join(','),
            items:    cart.items.map(function (item, i) {
              return {
                item_id:       item.handle,
                item_name:     item.product_title,
                item_brand:    item.vendor,
                price:         item.price / 100,
                quantity:      item.quantity,
                index:         i
              };
            })
          }
        });
      }).catch(function () {});
    });
  }

  // ─────────────────────────────────────────────────────────────
  // 컬렉션 — select_item
  // ─────────────────────────────────────────────────────────────

  function initCollectionTracking() {
    document.addEventListener('click', function (e) {
      var link = closest(e.target, 'a[href*="/products/"]');
      if (!link) return;

      var isQuickBuy = !!(closest(link, '[class*="quick"], [data-quick-buy]') ||
        link.textContent.toLowerCase().includes('quick'));

      var card = closest(link, '[class*="product-card"], [class*="product-item"], li');
      var titleEl = card && card.querySelector('h2, h3, [class*="title"]');
      var priceEl = card && card.querySelector('[class*="price"]');

      var handle = (link.href.split('/products/')[1] || '').split('?')[0].split('/')[0];

      push({
        event: 'select_item',
        ecommerce: {
          item_list_name: PAGE.collection_title || document.title,
          items: [{
            item_id:   handle,
            item_name: titleEl ? titleEl.textContent.trim() : handle,
            price:     priceEl ? parseFloat(priceEl.textContent.replace(/[^0-9.]/g, '')) || 0 : 0,
            index:     0
          }]
        },
        click_type: isQuickBuy ? 'quick_buy' : 'card'
      });
    });
  }

  // ─────────────────────────────────────────────────────────────
  // 블로그 이벤트
  // ─────────────────────────────────────────────────────────────

  function initBlogTracking() {
    var article = PAGE.article;

    // ── 본문 내 제품 링크 클릭 ───────────────────────────────────
    document.addEventListener('click', function (e) {
      var link = closest(e.target, 'a[href*="/products/"]');
      if (!link) return;

      var href   = link.getAttribute('href') || '';
      var handle = href.split('/products/')[1]?.split('?')[0] || href;
      var pos    = closest(link, 'article, .article__content') ? 'inline'
        : (closest(link, '.blog__cta, [class*="cta"]') ? 'cta_block' : 'other');

      push({
        event:               'blog_product_link_clicked',
        article_title:       article ? article.title : document.title,
        link_text:           link.textContent.trim().substring(0, 60),
        destination_product: handle,
        link_position:       pos
      });
    });

    // ── 태그 클릭 ────────────────────────────────────────────────
    document.addEventListener('click', function (e) {
      var tagLink = closest(e.target, 'a[href*="/blogs/news/tagged/"]');
      if (!tagLink) return;
      var tag = tagLink.getAttribute('href').split('/tagged/')[1] || '';
      push({
        event:    'blog_tag_clicked',
        tag_name: tag.split('?')[0]
      });
    });
  }

  // ─────────────────────────────────────────────────────────────
  // 스킨 퀴즈 이벤트
  // ─────────────────────────────────────────────────────────────

  function initQuizTracking() {
    // ── 퀴즈 시작 버튼 ──────────────────────────────────────────
    // iframe 외부 Shopify 페이지의 Start 버튼 (크로스오리진 무관, 직접 추적 가능)
    document.addEventListener('click', function (e) {
      var btn = closest(e.target, 'button, a');
      if (!btn) return;
      var text = btn.textContent.toLowerCase();
      if (!text.includes('quiz') && !text.includes('start')) return;
      // iframe 내부 요소 제외
      if (closest(btn, 'iframe')) return;

      var ref = 'direct';
      var referrer = document.referrer;
      if (referrer.includes('/blogs/')) ref = 'blog';
      else if (referrer.includes(window.location.hostname) && referrer !== '') ref = 'internal';
      else if (referrer === '') ref = 'direct';
      else ref = 'external';

      push({
        event:         'quiz_started',
        quiz_name:     'skin_match_quiz',
        referral_page: ref
      });
    });

    // ── Quizify postMessage 수신 ────────────────────────────────
    // Quizify 앱이 postMessage를 지원하는 경우 자동으로 동작
    // 지원 여부: Quizify 대시보드 > Settings > Integrations > postMessage Events
    window.addEventListener('message', function (e) {
      if (!e.origin.includes('quizify') && !e.origin.includes('arhamcommerce')) return;

      var data = e.data;
      if (typeof data === 'string') {
        try { data = JSON.parse(data); } catch (err) { return; }
      }
      if (!data || typeof data !== 'object') return;

      var evType = data.event || data.type || '';

      // 질문 답변
      if (/question|step|answer/i.test(evType)) {
        push({
          event:           'quiz_step_completed',
          quiz_name:       'skin_match_quiz',
          step_number:     data.step || data.question_index || data.questionIndex,
          answer_selected: data.answer || data.value || data.selectedAnswer
        });
      }

      // 퀴즈 완료 + 결과
      if (/complet|finish|result/i.test(evType)) {
        push({
          event:              'quiz_completed',
          quiz_name:          'skin_match_quiz',
          skin_type_result:   data.result || data.skin_type || data.skinType,
          recommended_product: data.product || data.recommendation
        });
      }

      // 결과 페이지 CTA 클릭
      if (/cta|click|recommend/i.test(evType)) {
        push({
          event:             'quiz_cta_clicked',
          quiz_name:         'skin_match_quiz',
          skin_type_result:  data.result || data.skin_type,
          cta_destination:   data.url || data.destination || data.href
        });
      }
    });
  }

  // ─────────────────────────────────────────────────────────────
  // 검색
  // ─────────────────────────────────────────────────────────────

  function initSearchTracking() {
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form.action || !form.action.includes('/search')) return;
      var input = form.querySelector('input[name="q"], input[type="search"]');
      if (!input) return;
      push({
        event:       'search',
        search_term: input.value.trim()
      });
    });
  }

  // ─────────────────────────────────────────────────────────────
  // INIT — 페이지 타입별 추적기 기동
  // ─────────────────────────────────────────────────────────────

  onReady(function () {
    var pt = PAGE.page_type || '';

    // 전 페이지 공통
    initNewsletterTracking();
    initSearchTracking();
    initCartTracking();

    // 페이지별 분기
    if (pt === 'index' || pt === 'home') {
      initHomepageTracking();
    }

    if (pt === 'product') {
      if (isHeroPage()) {
        initHeroProductTracking();
        initScrollDepth();
      }
    }

    if (pt === 'collection') {
      initCollectionTracking();
    }

    if (pt === 'article') {
      initBlogTracking();
      initScrollDepth();
    }

    if (pt === 'blog_list') {
      initBlogTracking();
    }

    // 퀴즈 페이지 (page template + handle 체크)
    if (pt === 'page' && PAGE.is_quiz) {
      initQuizTracking();
    }
    // 퀴즈 URL로 접근하는 모든 경우 커버
    if (window.location.pathname.includes('find-your-skin') || window.location.pathname.includes('quiz')) {
      initQuizTracking();
    }
  });

})();
